// Module Import
//---------------------------------
import 'slick-carousel/slick/slick.scss'
import '../../../assets/css/slick-theme.scss'

import React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import ImageCut from '../../../assets/images/graphic_imageCut.svg'
import BlogArticleCard from '../BlogArticleCard/BlogArticleCard'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const GalleryCarouselWrapper = styled.div`
  border-radius: 4px;
  position: relative;
  height: 100%;

  &:after {
    background-image: url(${ImageCut});
    background-repeat: no-repeat;
    background-size: 100%;
    bottom: 0;
    content: '';
    height: 30px;
    position: absolute;
    right: 0;
    width: 30px;
    z-index: 1;
  }

  @media only screen and (min-width: 48em) {
    &:after {
      background-image: url(${ImageCut});
      background-position: bottom right;
      background-size: cover;
      bottom: 0;
      content: '';
      height: 60px;
      position: absolute;
      right: 0;
      width: 60px;
      z-index: 1;
    }
  }

  &.one-slide {
    .gatsby-image-wrapper {
      width: 100%;
    }
  }

  .slick-slider {
    display: flex;
    flex-direction: column;
    height: 100%;

    .slick-track {
      height: 100%;

      .slick-slide > div {
        height: 100%;
      }
    }
  }
`

const Slide = styled.div`
  padding: 24px;
  height: 100%;
`

// Component Export
//---------------------------------
export default function ArticleCarousel({ carouselImages }) {
  const carouselSettings = {
    dots: true,
    infinite: carouselImages.length > 3,
    speed: 500,
    slidesToShow: carouselImages.length > 3 ? 3 : carouselImages.length,
    slidesToScroll: carouselImages.length > 3 ? 3 : carouselImages.length,
    autoplaySpeed: 4000,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: carouselImages.length > 3 ? 3 : carouselImages.length,
          slidesToScroll: carouselImages.length > 3 ? 3 : carouselImages.length,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: carouselImages.length > 2 ? 2 : carouselImages.length,
          slidesToScroll: carouselImages.length > 2 ? 2 : carouselImages.length,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <GalleryCarouselWrapper className={carouselImages.length === 1 ? 'one-slide' : ''}>
      <Slider {...carouselSettings}>
        {carouselImages.map((target) => (
          <Slide key={target?.id}>
            <BlogArticleCard
              imgSrc={target?.posterImage?.gatsbyImageData}
              altTag={target?.posterImage?.description || target?.articleTitle}
              header={target?.articleTitle}
              articleCategory={target?.articleCategory}
              articleShortDescription={target?.articleShortDescription}
              articleAuthor={target?.articleCategory === 'Snippets' ? '' : target?.articleAuthor}
              linkDestination={`posts/${target?.pageSlug}`}
              updatedDate={target?.updatedAt}
              publishedDate={target?.publishedDate}
              snippetYouTubeLink={target.snippetYouTubeLink}
              snippetVideoFile={target.snippetVideoFile}
            />
          </Slide>
        ))}
      </Slider>
    </GalleryCarouselWrapper>
  )
}
